import type { JSX } from 'react';
import styles from './fixcenter-support-visit-us.module.scss';
import React, { useState } from 'react';
import FixcenterSupportVisitUsDropDown from './fixcenter-support-visit-us-drop-down';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useTranslation } from '../../i18n/useTranslation';

const FixcenterSupportVisitUs: React.FC = (): JSX.Element => {
    const htmlId: string = 'fixcenter-support-visit-us';
    const { t } = useTranslation('translation');
    const [showDropDown, setShowDropDown] = useState<boolean>(false);
    const closeDropdown = () => {
        setShowDropDown(false);
    };
    const ref = useDetectClickOutside({ onTriggered: closeDropdown });

    const toggleDropDown = () => {
        setShowDropDown(!showDropDown);
    };

    const applySelectedClass = () => {
        return showDropDown ? `${styles.visit_us_btn} ${styles.selected_btn}` : `${styles.visit_us_btn}`;
    };

    return (
        <>
            <button
                ref={ref}
                id={`${htmlId}-btn`}
                className={applySelectedClass()}
                onClick={(): void => toggleDropDown()}
            >
                <label>{t('header.VISIT US')}</label>
                {showDropDown && <FixcenterSupportVisitUsDropDown />}
            </button>
        </>
    );
};

export default FixcenterSupportVisitUs;
